import { render, staticRenderFns } from "./userform.vue?vue&type=template&id=96fdf306&scoped=true"
import script from "./userform.vue?vue&type=script&lang=js"
export * from "./userform.vue?vue&type=script&lang=js"
import style0 from "./userform.vue?vue&type=style&index=0&id=96fdf306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fdf306",
  null
  
)

export default component.exports